export const LABEL = 'Only show enabled feedback once';
export const MESSAGE = 'Enabling this will only show the feedback once after the students have finished answering their quiz. This will only apply only if you have enabled to show the score, correct response, and/or rank percentile to students.';
